import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const WidgetService = {
  getList: async () => {
    try {
      const response = await apiService.get("/widgets");
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/widgets/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  create: async (data) => {
    const response = await apiService.post("/widgets", data);
    return response.data;
  },

  getdetail: async (id) => {
    const response = await apiService.get(`/widgets/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/widgets/${id}`);
    return response.data;
  },
};

export default WidgetService;
